import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';

import dataModel from '../../../models/DataModel';
import ReferenceDocument from './ReferenceDocument';
import { ReferenceDocumentHistory } from '../ReferenceDocumentHistory';
import './ReferenceDocumentDisplay.scss';

class ReferenceDocumentDisplay extends BaseComponent{
  constructor(props) {
    super(props);
    this.state = {
      referenceDocumentHistoryItems: null,
      currentReferenceDocument: null,
    };
    this.updateDocument = this.updateDocument.bind(this);
  }

  componentDidMount() {
    super.componentDidMount();
    
    //Fetch documents in history by group identifier
    const groupIdentifier = this.props.currentReferenceDocument.group_identifier;
    this.props.referenceDocumentsDataModel.fetchReferenceDocumentsByGroup(groupIdentifier, (historyDocuments) => {
      this.setState({
        referenceDocumentHistoryItems: historyDocuments,
      });
    });
    const id = this.props.currentReferenceDocument.id;
    dataModel.referenceDocumentsDAO.getReferenceDocument(id, { recordDescriptor: { reference_document: { conversions: { additionalFields: ['upload'] }, additionalFields: ['attachment'] } } }).then((refDoc) => {
      this.setState({ currentReferenceDocument: refDoc });
    });
  }

  handleBackArrow() {
    this.props.history.replace('/reference-documents');
  }

  handleReferenceDocumentError(errorResponse) {
    this.setState({
      referenceDocumentHistoryItems: [],
    });
    this.dataModel.displayHTTPError('Retrieving Reference Document History ', errorResponse.error);
  }

  updateDocument(newDocument) {
    this.setState({ currentReferenceDocument: newDocument });
  }

  render() {
    return <div className="reference-document-display">
      <div className="reference-document-header">
        <div className="back-arrow" onClick={this.handleBackArrow} />  
      </div>  
      <div className="reference-document-container">    
        <div className="reference-document-inner">
          <ReferenceDocument referenceDocument={this.state.currentReferenceDocument} updateDocument={this.updateDocument}/>  
        </div>
        <div className="divider"/>
        <ReferenceDocumentHistory historyItems={this.props.referenceDocumentHistoryItems ? this.props.referenceDocumentHistoryItems : this.state.referenceDocumentHistoryItems} />
      </div>  
    </div>;  
  }
}

;

const mapStateToProps = (state, ownProps) => {
  let currentReferenceDocument = ownProps['referenceDocument'];
  let referenceDocumentHistoryItems;
  if(state.referenceDocuments && state.referenceDocuments['group_identifier_' + currentReferenceDocument.group_identifier]){
    currentReferenceDocument = state.referenceDocuments['group_identifier_' + currentReferenceDocument.group_identifier].groupedReferenceDocuments[0];
    referenceDocumentHistoryItems = state.referenceDocuments['group_identifier_' + currentReferenceDocument.group_identifier].groupedReferenceDocuments;
  }
  return {
    dataModel: dataModel,
    mobileBridge: dataModel.mobileBridge,
    currentUser: state.new_users.currentUser,
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
    currentReferenceDocument: currentReferenceDocument,
    referenceDocumentsDataModel: dataModel.referenceDocumentsDataModel,
    referenceDocumentHistoryItems,
  };
};

// For handling state change from a dispatch
export default connect(mapStateToProps, null)(withRouter(ReferenceDocumentDisplay));



// WEBPACK FOOTER //
// ./src/containers/ReferenceDocumentsLibrary/ReferenceDocumentDisplay/index.js